import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Link from "next/link";
import styles from "@/components/Layouts/LeftSidebar/SubMenu.module.css";
import { useRouter } from "next/router";
import { useChatSocket } from "@/contexts/ChatSocketContext";

const SidebarLabel = styled("span")(({ theme }) => ({
	position: "relative",
	top: "-3px",
}));

const SubMenu = ({ item }) => {
	const [subnav, setSubnav] = useState(false);
	const showSubnav = () => setSubnav(!subnav);
	const [currentPath, setCurrentPath] = useState("");
	const router = useRouter();
	const { unreadCount } = useChatSocket() || {};

	useEffect(() => {
		setCurrentPath(router.asPath);
	}, [router]);

	return (
		<>
			<Link
				href={item.path}
				onClick={item.subNav && showSubnav}
				className={`${styles.sidebarLink} ${
					currentPath == item.path && "sidebarLinkActive"
				}`}
			>
				<div>
					{item.icon}
					<SidebarLabel className='ml-1'>
						{item.title}
					</SidebarLabel>
				</div>
				<div>
					{item.subNav && subnav
						? item.iconOpened
						: item.subNav
						? item.iconClosed
						: item.path === "/chat-intern" && unreadCount > 0
						? (
							<span
								style={{
									background: "#d32f2f",
									color: "#fff",
									borderRadius: "10px",
									fontSize: "11px",
									fontWeight: 600,
									padding: "1px 7px",
									minWidth: "18px",
									display: "inline-block",
									textAlign: "center",
								}}
							>
								{unreadCount > 99 ? "99+" : unreadCount}
							</span>
						)
						: null}
				</div>
			</Link>
			{subnav &&
				item.subNav.map((item, index) => {
					return (
						<Link
							href={item.path}
							key={index}
							className={`${styles.sidebarLink2} ${
								currentPath == item.path &&
								"sidebarLinkActive2"
							}`}
						>
							{item.icon}
							{item.title}
						</Link>
					);
				})}
		</>
	);
};

export default SubMenu;
